import "./LessonsFileViewer.css";
import "@react-pdf-viewer/core/lib/styles/index.css";
import "@react-pdf-viewer/default-layout/lib/styles/index.css";

import React, { useEffect } from "react";
import { Viewer, Worker } from "@react-pdf-viewer/core";
import { useAppDispatch, useAppSelector } from "../../../store";

import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { klassi } from "../../../utils/utils";
import { lessonActions } from "../../../store/slices/lessonSlice";
import { updateLessonMaterialThunk } from "../../../store/slices/userThunks";
import { useLoaUser } from "./lessonHooks";

export default function LessonsFileViewer() {
  const { loaUser } = useLoaUser();
  const material = useAppSelector((state) => state.lesson.material);
  const theme = useAppSelector((state) => state.app.theme);
  const [active, setActive] = React.useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const dispatch = useAppDispatch();

  const [page, setPage] = React.useState(0);
  const [scale, setScale] = React.useState(1.0);

  useEffect(() => {
    // listen for ESC key press to close the viewer
    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        close();
      }
    };
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  });

  useEffect(() => {
    // update the lesson material in the store
    if (material) {
      dispatch(
        updateLessonMaterialThunk({
          material,
          page,
          scale,
        })
      );
    }
  }, [material, page, scale, dispatch]);

  useEffect(() => {
    const act = !!material;
    setActive(act);
    if (act) {
      const lessonMaterial =
        loaUser?.courses?.[loaUser.currentCourse || ""]?.material?.[
          material?.uid || ""
        ];
      const initialPage = lessonMaterial?.page || 0;
      const defaultScale = lessonMaterial?.scale || 1.0;
      setPage(initialPage);
      setScale(defaultScale);
    }
  }, [material, loaUser]);

  const close = () => {
    dispatch(lessonActions.setMaterial(null));
  };

  const onPageChange = (e: { currentPage: number }) => {
    setPage(e.currentPage);
  };

  const onZoomChange = (e: { scale: number }) => {
    setScale(e.scale);
  };

  const klass = klassi({ active }, "lessons-file-viewer");

  console.log("LessonsFileViewer", {
    active,
    page,
    scale,
    material,
  });

  return (
    <div className={klass}>
      {active && (
        <>
          <div className="lessons-file-viewer-header">
            <div />
            <h4>{material?.name}</h4>
            <div className="close-button" onClick={close}>
              <i className="fa fa-times"></i>
            </div>
          </div>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
            {material && (
              <Viewer
                fileUrl={material.uri}
                plugins={[defaultLayoutPluginInstance]}
                defaultScale={scale}
                onPageChange={onPageChange}
                onZoom={onZoomChange}
                initialPage={page}
                theme={theme}
              />
            )}
          </Worker>
        </>
      )}
    </div>
  );
}
